import React from "react";
import { useI18n } from "../i18n";
import { useSeo } from "../hooks/useSeo";
import { pathFor } from "../config/site";
import { IMAGES } from "../data/structure";
import { webpageLd, breadcrumbLd } from "../lib/jsonld";
import PageHero from "../components/PageHero";
import { Section } from "../components/Section";

export default function AboutPage({ pageKey }) {
  const { lang, d } = useI18n();
  const meta = d.meta.about;
  useSeo({
    pageKey,
    title: meta.title,
    description: meta.description,
    jsonLd: [
      webpageLd({ lang, pageKey, title: meta.title, description: meta.description }),
      breadcrumbLd([
        { name: d.ui.nav.home, path: pathFor(lang, "home") },
        { name: d.ui.nav.about, path: pathFor(lang, "about") },
      ]),
    ],
  });

  return (
    <>
      <PageHero testid="about-hero" title={d.pages.about.heading} image={IMAGES.bridge} />
      <Section>
        <div className="max-w-3xl space-y-6">
          {d.pages.about.paragraphs.map((p, i) => (
            <p key={i} className="text-base sm:text-lg text-jlo-warm/80 leading-relaxed">{p}</p>
          ))}
          <div className="glass rounded-2xl p-6 mt-8">
            <p className="text-sm text-jlo-gold/90 font-semibold uppercase tracking-wider mb-2">{d.footer.notOfficial}</p>
            <p className="text-sm text-jlo-warm/75 leading-relaxed">{d.disclaimer.long}</p>
          </div>
        </div>
      </Section>
    </>
  );
}
